module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td colspan="5">\n    ';
 if(state.loading) { 
__p+='\n    <div class="processing">\n        <img src="/static/icons/cog.svg" class="cogicon" /><br/>\n        Loading...\n    </div>    \n    ';
 } else { 
__p+='\n    <div class="processing">\n        No results\n    </div>\n    ';
 } 
__p+='\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/empty.html
// module id = 256
// module chunks = 0